module.exports = __webpack_public_path__ + "img/io.3ff21d10.png";